import {
  useContext,
} from 'react';
import ToastCtx from 'common/contexts/ToastContext';

const ARMAGEDDON_DELAY = 3000;

export type Toast = {
  id: number;
  text: string;
  variant: 'error' | 'default' | 'success';
}

const useToasts = () => {
  const { setToast } = useContext<any>(ToastCtx);
  const toast = (text: string, variant: string) => {
    const newId = new Date().getTime();
    setToast((prevState: any[]) => [...prevState, { text, variant, id: newId }]);
    setTimeout(() => setToast((prevState: any[]) => prevState.filter((item) => item.id !== newId)), ARMAGEDDON_DELAY);
  }

  return toast;
}

export default useToasts;
